import { COOKIE_NAME_HAS_ACCEPTED_COOKIES } from '../constants';

import Cookies from '../services/cookies';
import { generate } from '../../../core/js/utils/componentUtils';
import { dDom } from '../../../core/js/utils/renderUtils';
import { isWebview } from '../../../core/js/utils/cookieUtils';
import template from 'cookies-alert.j2';
import { userAgreedToCookies } from '../actions/cookiesAlertActions';
import { createGAEvent } from '@core/js/utils/analyticsUtils';
import { handleUtagEvent } from '@core/js/actions/initialActions';

function isNotIntegrationTest() {
    const integrationTestSettings = window.__urbnIntegrationTestSettings || {};
    return !_.get(integrationTestSettings, 'suppressCookieAlert', false);
}

export function getCookieBannerCookieName(store) {
    const { core } = store.getState();
    // NOTE Cookie banner cookie now gets siteGroup appended to it.
    // Aligns with PWA cookie banner cookie string.
    return `${COOKIE_NAME_HAS_ACCEPTED_COOKIES}_${core.siteConfig.siteGroup}`;
}

export function dismissCookieAlert(store) {
    const { core } = store.getState();
    Cookies.setCookie(`${COOKIE_NAME_HAS_ACCEPTED_COOKIES}_${core.siteConfig.siteGroup}`, 'true');
    store.dispatch(userAgreedToCookies(true));
}

/**
 * Attach component events to DOM
 * @param {Object} store Redux store
 * @returns {undefined}
 */
export function attachEvents(store) {
    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-agree-to-cookies'), () => {
        const gaEvent = createGAEvent(
            'PAGE_TYPE',
            'Tracking Cookies',
            'Accepted'
            );
        store.dispatch(handleUtagEvent(gaEvent, 'link'));
        dismissCookieAlert(store);
    });
}

export function onStateChange(store) {
    if (!isWebview()) {
        this.render(store, this, {});
    }
}

// NOTE Need a first render because clientsideCookieDetectionSet is set to true before this component
// is created (in cookieSagas), so onStateChange won't fire (because watcher values haven't changed after
// construction) and render the component if the user hasn't accepted cookies before
function firstRender(store) {
    const cookieBannerCookieName = getCookieBannerCookieName(store);
    const isCookieAttached = Cookies.getCookieByName(cookieBannerCookieName);

    if (isCookieAttached !== '') { return; }
    this.render(store, this, {});
}

/**
 * Bootstrap the component onto the page
 * @param {Object} store Redux store
 * @param {Object} overrides optional overridden component properties
 * @returns {Object} the generated component
 */
export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-cookies-alert',
        className: 'dom-cookies-alert',
        watch: ['core.userHasAgreedToCookies', 'core.clientsideCookieDetectionSet'],
        name: 'cookiesAlertComponent',
        firstRender: firstRender,
        attachEvents: attachEvents,
        renderType: dDom,
        onStateChange: onStateChange,
        template: template,
        isComponentValid: isNotIntegrationTest || _.get(store.getState(), 'core.constants.cookiesBanner.enabled', true),
    };

    return generate(config, store, overrides);
}
